import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 16px;
  gap: 16px;
  padding: 16px 32px 16px 32px;
  width: 80%;
  height: 20%;
  max-width: 830px;
  max-height: 256px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  align-content: center;
`;

export const ModalHeader = styled.div`
  margin-bottom: 16px;
`;

export const ModalBody = styled.div`
  margin-bottom: 24px;
  color: ${({ theme }) => theme.tokens.color.text.secondary};
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;
